function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1045-1330H875V713h-1920z"
}), React.createElement("path", {
  d: "M-1045-1034H875V636h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "m113.19 65.428 17.988 17.988-24.708 24.708-4.2-4.2-1.057 1.057a3.785 3.785 0 0 1-2.693 1.115 3.796 3.796 0 0 1-2.706-1.131l-.032.03-15.377-16.147a5.972 5.972 0 0 1-1.655-4.136c0-1.601.624-3.107 1.757-4.24l1.618-1.618 4.507 4.733 18.158-18.159 4.2 4.2 4.2-4.2zm0 2.376-3.012 3.012 12.6 12.6-19.32 19.32 3.012 3.012 22.332-22.332-15.612-15.612zm-8.4 0L87.791 84.803l12.292 12.908-3.07 3.07a2.118 2.118 0 0 0-.623 1.505c0 1.174.956 2.13 2.13 2.13.569 0 1.104-.222 1.506-.623l20.376-20.377-15.612-15.612zM82.096 81.258l-.401.4a4.292 4.292 0 0 0-1.265 3.054 4.3 4.3 0 0 0 1.191 2.979l13.167 13.825a3.785 3.785 0 0 1 1.038-1.924l1.91-1.91-15.64-16.424zm12.86-.956 1.187 1.188-1.68 1.68-1.187-1.188 1.68-1.68zm10.08-10.08 1.187 1.188-8.4 8.4-1.187-1.188 8.4-8.4z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 81.16,
  y: 138.719
}, "Gazety")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/gazety.9c59aef5.svg";
export { SvgComponent as ReactComponent };